import { Skeleton } from 'antd';
import classNames from 'classnames';
import { FC, HTMLAttributes } from 'react';

import './NewsCard.scss';

interface SkeletonNewsCardProps extends HTMLAttributes<HTMLElement> {
  className?: string;
  showImage?: boolean;
}

export const SkeletonNewsCard: FC<SkeletonNewsCardProps> = ({ className, showImage = true, ...restProps }) => {
  return (
    <article
      {...restProps}
      className={classNames(
        'custom-news-card',
        'custom-news-card--skeleton',
        {
          'custom-news-card--no-image': !showImage,
        },
        className,
      )}
    >
      {showImage && (
        <div className="custom-news-card__head">
          <Skeleton.Image active className="custom-news-card__image" />
        </div>
      )}
      <div className="custom-news-card__body">
        <div className="custom-news-card__info">
          <div className="custom-news-card__date-wrapper">
            <Skeleton.Avatar active size="small" shape="square" style={{ width: 16, height: 16, minWidth: 16 }} />
            <Skeleton.Input active size="small" style={{ width: 100, height: 14 }} />
          </div>
          <div className="custom-news-card__content-wrapper">
            <Skeleton.Input active block size="small" style={{ height: 20, marginBottom: 4 }} />
            <Skeleton.Input active block size="small" style={{ height: 20, marginBottom: 4 }} />
            <Skeleton.Input active block size="small" style={{ height: 16, marginBottom: 4 }} />
            <Skeleton.Input active block size="small" style={{ height: 16 }} />
          </div>
        </div>
        <Skeleton.Button active size="small" style={{ width: 120, height: 32 }} />
      </div>
    </article>
  );
};
